import cityTimezones from 'city-timezones';
import { sortBy } from 'lodash';
import moment from 'moment-timezone';
import { SelectorOptionPropsInterface } from 'sonata-react-components';
import { worldCountries } from 'sonata-static-storage/lib/samples/worldCountries.samples';

import { allCountries } from '@/global/allCountries';

export const countriesOptions: SelectorOptionPropsInterface[] = sortBy(
  worldCountries.map(worldCountry => ({
    id: worldCountry.cca3.toLowerCase(),
    label: worldCountry.name.common
  })),
  'label'
);

export const countriesISO2Options: SelectorOptionPropsInterface[] = sortBy(
  Object.values(allCountries).map(country => ({
    id: country.countryCode,
    label: country.name
  }))
);

export function getTimeZonesByCountry(countryCode: string): string[] {
  let alpha2 = countryCode;
  if (countryCode.length === 3) {
    const match = worldCountries.find(c => c.cca3.toLowerCase() === countryCode.toLowerCase());
    if (match && match.cca2) {
      alpha2 = match.cca2;
    }
  }
  try {
    const timezones = moment.tz.zonesForCountry(alpha2);
    if (!Array.isArray(timezones)) {
      return [];
    }
    return timezones;
  } catch {
    return [];
  }
}

const normalize = (str: string) =>
  str
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .replace(/[áàäâãå]/gi, 'a')
    .replace(/[éèëê]/gi, 'e')
    .replace(/[íìïî]/gi, 'i')
    .replace(/[óòöôõö]/gi, 'o')
    .replace(/[úùüû]/gi, 'u')
    .replace(/[ç]/gi, 'c');

export function getCapitalTimeZone(countryCode: string): string | undefined {
  let alpha2 = countryCode;
  if (countryCode.length === 3) {
    const match = worldCountries.find(c => c.cca3.toLowerCase() === countryCode.toLowerCase());
    if (match && match.cca2) {
      alpha2 = match.cca2;
    }
  }

  const country = worldCountries.find(c => c.cca2.toLowerCase() === alpha2.toLowerCase());
  const capital = country?.capital;

  if (!capital) {
    return undefined;
  }

  const nameMapping: Record<string, string> = {
    'El Aaiún': 'Laayoune',
    'Washington D.C.': 'Washington, D.C.'
  };

  const normalizedCapital = normalize(capital);

  const cityLookup = cityTimezones.lookupViaCity(nameMapping[capital] || normalizedCapital);

  return cityLookup?.[0]?.timezone;
}

export function getCountriesValuesOptions(countries: string[] = []): SelectorOptionPropsInterface[] {
  return countries.map((val: string) => ({
    id: val,
    label: worldCountries.find(country => country.cca3.toLowerCase() === val)?.name.common
  }));
}
